module.exports = __webpack_public_path__ + "static/science of evidence second edition-4aa80bdd366a9da39cab777aca81602c.jpg";